import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { CommonState } from "@obg/ngx.common";

import { RegistrationFeatureState } from "../../state";

import { ACTION_PREFIX } from "./registration-with-personal-number.action";
import {
	PersonalNumberInformationLevel,
	RegistrationWithPersonalNumberState,
} from "./registration-with-personal-number.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationWithPersonalNumberSelector {
	getState() {
		return (state: RegistrationFeatureState): RegistrationWithPersonalNumberState =>
			state.registrationFeature.registrationWithPersonalNumber;
	}

	getPersonalNumber() {
		return (state: RegistrationFeatureState): string | undefined =>
			state.registrationFeature.registrationWithPersonalNumber.personalNumber;
	}

	getPersonalNumberInformationLevel() {
		return (state: RegistrationFeatureState): PersonalNumberInformationLevel | undefined =>
			state.registrationFeature.registrationWithPersonalNumber.personalNumberInformationLevel;
	}

	isBusy() {
		return (state: RegistrationFeatureState & CommonState): boolean =>
			FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}
}
